import { render } from "./RewardPopUp.vue?vue&type=template&id=b8ee3d9a&scoped=true"
import script from "./RewardPopUp.vue?vue&type=script&lang=js"
export * from "./RewardPopUp.vue?vue&type=script&lang=js"

import "./RewardPopUp.vue?vue&type=style&index=0&id=b8ee3d9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ee3d9a"]])

export default __exports__